import React from "react"
import SpotifyPlayer from 'react-spotify-player'
import uproot from '../images/uproot.jpg'

const UPROOT_DESC = `UPROOT is a space for stories of movement, belonging, and reinvention. In each conversation, I speak with people who have left their home countries and started anew in the United States. Together, we talk about what it means to feel uprooted — and to grow new roots.`

export default function Podcast() {
  return (
    <div style={wrap} id="podcast">
      <div style={inner} className="podcast-inner">
        <h2 style={sectionTitle}>Podcasts</h2>

        {/* UPROOT */}
        <div style={uprootGrid} className="uproot-grid">
          <a href="https://open.spotify.com/show/1HsLjyN9uZiXdVgQK21Iix" target="_blank" rel="noreferrer" style={coverLink} className="uproot-cover">
            <img src={uproot} alt="Uproot Podcast" style={coverImg} />
          </a>
          <div style={uprootText}>
            <p style={labelStyle}>Original Podcast</p>
            <p style={uprootTitle}>UPROOT</p>
            <p style={descStyle}>{UPROOT_DESC}</p>
            <div style={spotifyWrap}>
              <SpotifyPlayer
                uri="https://open.spotify.com/show/1HsLjyN9uZiXdVgQK21Iix"
                size={{ width: "100%", height: "152px" }}
                view="list"
                theme="black"
              />
            </div>
          </div>
        </div>

      </div>

      <style>{`
        @media (max-width: 900px) {
          .uproot-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .uproot-cover { max-width: 200px !important; margin: 0 auto !important; }
        }
        @media (max-width: 600px) {
          .podcast-inner { padding: 0 20px !important; }
        }
      `}</style>
    </div>
  )
}

const wrap = {
  background: "var(--cobalt)",
  padding: "80px 0",
}

const inner = {
  maxWidth: "1320px",
  margin: "0 auto",
  padding: "0 40px",
}

const sectionTitle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "32px",
  letterSpacing: "0.04em",
  color: "white",
  marginBottom: "48px",
}

const uprootGrid = {
  display: "grid",
  gridTemplateColumns: "240px 1fr",
  gap: "48px",
  alignItems: "start",
}

const coverLink = {
  display: "block",
}

const coverImg = {
  width: "100%",
  display: "block",
  marginBottom: 0,
}

const uprootText = {}

const labelStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.22em",
  textTransform: "uppercase",
  color: "var(--gold)",
  marginBottom: "10px",
}

const uprootTitle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "28px",
  color: "white",
  marginBottom: "16px",
  letterSpacing: "0.1em",
}

const descStyle = {
  fontSize: "17px",
  lineHeight: 1.7,
  color: "rgba(255,255,255,0.72)",
  marginBottom: "24px",
}

const spotifyWrap = {
  maxWidth: "500px",
}
